import { apiFetch } from './api';

// â”€â”€â”€ TYPES â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€

export interface Asset {
  id: string;
  homeId: string;
  userId: string;
  name: string;
  category: string;
  brand?: string;
  model?: string;
  serialNumber?: string;
  purchasedAt?: string;
  warrantyExpiresAt?: string;
  location?: string;
  purchaseYear?: number;
  purchaseMonth?: number;
  notes?: string;
  imageUrl?: string;

  // AI-enriched fields
  productTitle?: string;
  productDescription?: string;
  productCategory?: string;
  subCategory?: string;
  manufacturer?: string;
  barcode?: string;
  productImageUrl?: string;
  productColor?: string;
  enrichmentSource?: string;

  // Purchase & Value
  purchasePrice?: number;
  currentValue?: number;
  tradeInValue?: number;
  energyUsageKwh?: number;

  // Warranty details
  warrantyProvider?: string;
  warrantyNumber?: string;
  warrantyType?: string;
  warrantyCoverage?: string[];
  warrantyExclusions?: string[];
  deductible?: number;
  maxClaimAmount?: number;
  claimsUsed?: number;

  // Health & Risk
  healthScore?: number;
  lastHealthUpdate?: string;
  keyRisks?: string[];

  // BrandSmart import fields
  brandSmartReceiptNo?: string;
  deliveryAddress?: string;
  manufacturerWarrantyStatus?: string;
  manufacturerWarrantyExpiry?: string;
  extendedWarrantyStatus?: string;
  extendedWarrantyExpiry?: string;
  extendedWarrantyYears?: number;
  extendedWarrantyProvider?: string;
  underwriter?: string;

  // Manual warranty registration
  warrantyRegisteredEmail?: string;
  warrantyRegisteredName?: string;

  createdAt: string;
  updatedAt: string;

  // Smart maintenance
  conditionOnAdd?: string;
  scheduleGenerated?: boolean;
  scheduleGeneratedAt?: string;

  home?: {
    id: string;
    name: string;
  };
  user?: {
    id: string;
    name: string;
    email: string;
    avatarUrl?: string;
  };
  documents?: AssetDocument[];
  issues?: AssetIssue[];
  maintenanceRecords?: AssetMaintenanceRecord[];
  protectionPlans?: AssetProtectionPlan[];
  _count?: {
    issues: number;
    maintenanceRecords: number;
    documents: number;
  };
}

export interface AssetDocument {
  id: string;
  assetId: string;
  name: string;
  type: string;
  url: string;
  mimeType: string;
  sizeBytes: number;
  createdAt: string;
}

export interface AssetIssue {
  id: string;
  title: string;
  description: string;
  severity: 'low' | 'medium' | 'high' | 'critical';
  status: 'open' | 'in_progress' | 'resolved' | 'closed';
  createdAt: string;
  resolvedAt?: string;
}

export interface AssetMaintenanceRecord {
  id: string;
  title: string;
  description?: string;
  performedAt: string;
  nextDueAt?: string;
  cost?: number;
  createdAt: string;
}

export interface AssetProtectionPlan {
  id: string;
  planName: string;
  provider: string;
  billingPeriod: string;
  price: number;
  priceLabel: string;
  deductible?: number;
  features: string[];
  coverageStart: string;
  coverageEnd?: string;
  isActive: boolean;
}

export interface CreateAssetDto {
  homeId: string;
  name: string;
  category: string;
  subCategory?: string;
  brand?: string;
  model?: string;
  serialNumber?: string;
  purchasedAt?: string;
  warrantyExpiresAt?: string;
  location?: string;
  purchaseYear?: number;
  purchaseMonth?: number;
  notes?: string;
  imageUrl?: string;
  purchasePrice?: number;
  warrantyProvider?: string;
  warrantyNumber?: string;
  warrantyType?: string;
  // AI-enriched fields (parity with mobile app)
  productTitle?: string;
  productDescription?: string;
  productCategory?: string;
  manufacturer?: string;
  mpn?: string;
  barcode?: string;
  productImageUrl?: string;
  productColor?: string;
  enrichmentSource?: string;
  conditionOnAdd?: string;
}

export interface UpdateAssetDto {
  name?: string;
  category?: string;
  brand?: string;
  model?: string;
  serialNumber?: string;
  purchasedAt?: string;
  warrantyExpiresAt?: string;
  location?: string;
  purchaseYear?: number;
  purchaseMonth?: number;
  notes?: string;
  imageUrl?: string;
  productImageUrl?: string;
  purchasePrice?: number;
  currentValue?: number;
  tradeInValue?: number;
  energyUsageKwh?: number;
  warrantyProvider?: string;
  warrantyNumber?: string;
  warrantyType?: string;
  warrantyCoverage?: string[];
  warrantyExclusions?: string[];
  deductible?: number;
  maxClaimAmount?: number;
  claimsUsed?: number;
  // Manual warranty fields
  manufacturerWarrantyStatus?: string;
  manufacturerWarrantyExpiry?: string;
  extendedWarrantyStatus?: string;
  extendedWarrantyExpiry?: string;
  extendedWarrantyYears?: number;
  extendedWarrantyProvider?: string;
  underwriter?: string;
  warrantyRegisteredEmail?: string;
  warrantyRegisteredName?: string;
  healthScore?: number;
  keyRisks?: string[];
}

// â”€â”€â”€ API FUNCTIONS â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€

export const createAsset = async (data: CreateAssetDto): Promise<Asset> => {
  const response = await apiFetch<{ success: boolean; data: Asset }>('/v1/assets', {
    method: 'POST',
    body: data,
  });
  return response.data;
};

export const getHomeAssets = async (homeId: string): Promise<Asset[]> => {
  const response = await apiFetch<{ success: boolean; data: Asset[] }>(`/v1/assets?homeId=${homeId}`);
  return response.data;
};

export const getAssetsByCategory = async (homeId: string, category: string): Promise<Asset[]> => {
  const response = await apiFetch<{ success: boolean; data: Asset[] }>(`/v1/assets?homeId=${homeId}&category=${category}`);
  return response.data;
};

export const getAssetById = async (assetId: string): Promise<Asset> => {
  const response = await apiFetch<{ success: boolean; data: Asset }>(`/v1/assets/${assetId}`);
  return response.data;
};

export const updateAsset = async (assetId: string, data: UpdateAssetDto): Promise<Asset> => {
  const response = await apiFetch<{ success: boolean; data: Asset }>(`/v1/assets/${assetId}`, {
    method: 'PUT',
    body: data,
  });
  return response.data;
};

export const deleteAsset = async (assetId: string): Promise<void> => {
  await apiFetch<{ success: boolean; data: null }>(`/v1/assets/${assetId}`, {
    method: 'DELETE',
  });
};

// â”€â”€â”€ MANUAL WARRANTY OTP â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€

export interface ManualWarrantyPayload {
  purchasedAt?: string;
  mfgEnabled: boolean;
  extEnabled: boolean;
  extProvider?: string;
  extYears?: number;
  extendedPlanData?: Record<string, unknown>;
  extendedWarrantyStartDate?: string;
  targetHomeId?: string;
  createNewHome?: boolean;
  deliveryAddress?: string;
  warrantySource?: string;
}

export const saveManualWarranty = async (assetId: string, payload: ManualWarrantyPayload): Promise<Asset> => {
  const res = await apiFetch<{ success: boolean; data: Asset }>(`/v1/assets/${assetId}/warranty`, {
    method: 'PATCH',
    body: payload,
  });
  return res.data;
};

// â”€â”€â”€ ASSET CATEGORIES â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€

export const ASSET_CATEGORIES = [
  'Appliance',
  'HVAC',
  'Plumbing',
  'Electrical',
  'Electronics',
  'Furniture',
  'Outdoor',
  'Security',
  'Other',
] as const;

export type AssetCategory = typeof ASSET_CATEGORIES[number];

// Category-specific subcategories for better organization
export const ASSET_SUBCATEGORIES: Record<string, string[]> = {
  Appliance: ['Refrigerator', 'Washer', 'Dryer', 'Dishwasher', 'Oven', 'Microwave', 'Range', 'Freezer'],
  HVAC: ['Air Conditioner', 'Furnace', 'Heat Pump', 'Thermostat', 'Humidifier', 'Air Purifier'], 
  Plumbing: ['Water Heater', 'Sump Pump', 'Garbage Disposal', 'Faucet', 'Toilet', 'Shower'],
  Electrical: ['Panel', 'Generator', 'Solar Panel', 'Battery Backup', 'Smart Switch'],
  Electronics: ['TV', 'Sound System', 'Router', 'Smart Home Hub', 'Camera', 'Doorbell'],
  Furniture: ['Sofa', 'Bed', 'Table', 'Chair', 'Desk', 'Cabinet', 'Shelving'],
  Outdoor: ['Lawn Mower', 'Grill', 'Pool Equipment', 'Sprinkler System', 'Patio Furniture'],
  Security: ['Alarm System', 'Camera', 'Smart Lock', 'Motion Sensor', 'Smoke Detector'],
  Other: ['Tool', 'Ladder', 'Storage', 'Decor', 'Miscellaneous'],
};

// Room/location options
export const ASSET_LOCATIONS = [
  'Kitchen',
  'Living Room',
  'Bedroom',
  'Bathroom',
  'Garage',
  'Basement',
  'Attic',
  'Laundry Room',
  'Office',
  'Dining Room',
  'Outdoor',
  'Utility Room',
  'Other',
] as const;

export type AssetLocation = typeof ASSET_LOCATIONS[number];

// â”€â”€â”€ LABEL EXTRACTION (AI Vision) â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€

export interface EnrichmentStep {
  step: number;
  name: string;
  status: 'success' | 'partial' | 'failed' | 'skipped';
  message: string;
}

export interface ExtractedLabelData {
  brand?: string;
  model?: string;
  serialNumber?: string;
  confidence: number;
  imageUrl?: string;
  description?: string;
  enrichmentSteps?: EnrichmentStep[];
  dataQuality?: 'excellent' | 'good' | 'partial' | 'minimal';
  enrichmentSource?: string;
  detectedProductType?: string;
  // AI-enriched fields â€” passed through to asset creation payload
  productTitle?: string;
  productDescription?: string;
  productCategory?: string;
  manufacturer?: string;
  mpn?: string;
  barcode?: string;
  productColor?: string;
  searchQueries?: string[];
  productSubtype?: string;
}

export interface LabelLocationInstructions {
  brand: string;
  category: string;
  subcategory: string;
  steps: string[];
  alternateLocations: string[];
  safetyTips: string[];
  visualGuideUrl?: string;
}

const API_BASE = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';

// Backend origin for static assets. Strips the trailing /api so that relative
// image paths like "/images/products/refrigerator/default.jpeg" (served by the
// backend at its root, NOT under /api) resolve to the API host instead of the
// frontend dev server (localhost:3000).
const IMAGE_ORIGIN = API_BASE.replace(/\/api\/?$/, '');

/**
 * Make a backend image URL safe to use as an <img src>.
 * - Absolute (http/https), data:, blob: URLs pass through unchanged (SERP results).
 * - Root-relative paths (curated/seed images, e.g. "/images/..") get the backend origin.
 */
export function toAbsoluteImageUrl(u: string | null | undefined): string {
  if (!u) return '';
  // Backend-uploaded images live under `/uploads/…`. They may have been stored
  // as a host-absolute URL by the device that uploaded them (e.g. the mobile app
  // on a LAN IP) — a host the browser can't reach. Re-anchor any `/uploads/…`
  // path to this frontend's backend origin so images sync across every client.
  const uploadsIdx = u.indexOf('/uploads/');
  if (uploadsIdx >= 0) return `${IMAGE_ORIGIN}${u.slice(uploadsIdx)}`;
  if (/^(https?:|data:|blob:)/i.test(u)) return u;
  if (u.startsWith('/')) return `${IMAGE_ORIGIN}${u}`;
  return u;
}

function getAuthHeader(): Record<string, string> {
  try {
    const raw = localStorage.getItem('auth-storage');
    if (!raw) return {};
    const parsed = JSON.parse(raw);
    const token = parsed?.state?.accessToken;
    if (!token) return {};
    return { Authorization: `Bearer ${token}` };
  } catch {
    return {};
  }
}

function getTenantHeader(): Record<string, string> {
  return { 'X-Tenant-Slug': 'brandsmart' };
}

export const extractLabelFromImage = async (file: File, assetType?: string): Promise<ExtractedLabelData> => {
  // Convert image to base64 for V1 AI endpoint
  const base64Image = await new Promise<string>((resolve, reject) => {
    const reader = new FileReader();
    reader.onloadend = () => {
      const result = reader.result as string;
      // Extract base64 data (remove data:image/...;base64, prefix)
      const base64 = result.split(',')[1] || result;
      resolve(base64);
    };
    reader.onerror = reject;
    reader.readAsDataURL(file);
  });

  // V1 AI endpoint â€” one call does: OpenAI vision + barcode 3-tier enrichment + SERP image lookup
  const res = await fetch(`${API_BASE}/v1/ai/analyze-label`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      ...getAuthHeader(),
      ...getTenantHeader(),
    },
    // Only send assetType when a real value is known â€” mirrors the app's behavior.
    // Omitting it lets the backend infer the type from the label itself (more accurate).
    body: JSON.stringify({ image: base64Image, ...(assetType?.trim() ? { assetType: assetType.trim() } : {}) }),
  });

  if (!res.ok) {
    const err = await res.json().catch(() => ({ message: 'Label extraction failed' }));
    console.error('[extractLabelFromImage] Backend error:', err);
    // Prefer rejectionReason (detailed user message) over message (technical error)
    const errorMsg = err.rejectionReason || err.message || 'Label extraction failed';
    console.error('[extractLabelFromImage] Throwing error:', errorMsg);
    throw new Error(errorMsg);
  }

  const json = await res.json();

  // V1 AI response now includes a canonical `product` field (EnrichedProduct shape)
  // shared with the Flutter app. Prefer it over legacy flat fields.
  const data = json.data;
  const p = data.product ?? {};
  return {
    brand: p.brand ?? data.brand,
    model: p.model ?? data.model,
    serialNumber: p.serial ?? data.serial,
    confidence: 0.85,
    imageUrl: p.imageUrl ?? data.productImageUrl ?? undefined,
    description: p.description ?? data.productDescription,
    enrichmentSteps: undefined,
    dataQuality:
      (p.enrichmentSource ?? data.enrichmentSource) === 'merged' ? 'good' : 'partial',
    enrichmentSource: p.enrichmentSource ?? data.enrichmentSource,
    detectedProductType: p.productType ?? data.productType,
    // Enriched fields â€” carry through for asset creation payload parity with app
    productTitle: p.productTitle ?? data.productTitle ?? undefined,
    productDescription: p.description ?? data.productDescription ?? undefined,
    productCategory: p.productCategory ?? data.productCategory ?? undefined,
    manufacturer: p.manufacturer ?? data.manufacturer ?? undefined,
    mpn: p.mpn ?? data.mpn ?? undefined,
    barcode: p.barcode ?? data.barcode ?? undefined,
    productColor: p.productColor ?? data.productColor ?? undefined,
    searchQueries: (p.searchQueries ?? data.searchQueries) ?? undefined,
    productSubtype: p.productSubtype ?? data.productSubtype ?? undefined,
  };
};

export const uploadAssetDocuments = async (assetId: string, files: File[], types?: string[]): Promise<void> => {
  // Backend expects one file at a time via multipart POST using field name "file"
  // Endpoint: POST /api/v1/assets/:id/documents/upload
  for (let i = 0; i < files.length; i++) {
    const file = files[i];
    const docType = types?.[i] || 'other';
    const formData = new FormData();
    formData.append('file', file);
    formData.append('name', file.name);
    formData.append('type', docType);

    const res = await fetch(`${API_BASE}/v1/assets/${encodeURIComponent(assetId)}/documents/upload`, {
      method: 'POST',
      headers: {
        ...getAuthHeader(),
        ...getTenantHeader(),
      },
      body: formData,
    });

    if (!res.ok) {
      const err = await res.json().catch(() => ({ message: 'Document upload failed' }));
      throw new Error(err.message || 'Document upload failed');
    }
  }
};

export const getLabelGuide = async (
  brand: string,
  category: string,
  subcategory: string,
  assetType?: string
): Promise<LabelLocationInstructions> => {
  const res = await fetch(`${API_BASE}/v1/ai/label-guide`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      ...getAuthHeader(),
      ...getTenantHeader(),
    },
    body: JSON.stringify({
      assetType: assetType || category,
      brand,
      subCategory: subcategory,
    }),
  });

  if (!res.ok) {
    const err = await res.json().catch(() => ({ message: 'Failed to get label guide' }));
    throw new Error(err.message || 'Failed to get label guide');
  }

  const json = await res.json();
  const raw = json.data || json;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const labels: any[] = raw.labels || {};
  const guidance = raw.guidance || {};
  const steps: string[] = (guidance as { steps?: string[] }).steps?.length
    ? (guidance as { steps: string[] }).steps
    : (labels as Array<Record<string, string>>)
        .map((l) => l.full_description || l.description || l.short_label || '')
        .filter((s: string) => s.length > 0);
  const alternateLocations: string[] = (labels as Array<Record<string, string>>)
    .slice(1)
    .map((l) => l.short_label || l.position || '')
    .filter((s: string) => s.length > 0);
  const safetyTips: string[] = [
    'Unplug the appliance before reaching behind or underneath it.',
    'Use a flashlight if the label area is dimly lit.',
    'Take a photo of the label for future reference.',
  ];
  return {
    brand,
    category,
    subcategory,
    steps: steps.length > 0 ? steps : [`Check the back panel of your ${brand} ${subcategory} for the product label.`],
    alternateLocations,
    safetyTips,
    visualGuideUrl: raw.imageUrl || undefined,
  };
};

export const getLabelLocationInstructions = async (
  brand: string,
  category: string,
  subcategory: string,
  assetType?: string
): Promise<LabelLocationInstructions> => {
  // V1 AI endpoint expects POST with body
  const res = await fetch(`${API_BASE}/v1/ai/label-locations`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      ...getAuthHeader(),
      ...getTenantHeader(),
    },
    body: JSON.stringify({ assetType: category, brand, subCategory: subcategory, specificAssetType: assetType || '' }),
  });

  if (!res.ok) {
    const err = await res.json().catch(() => ({ message: 'Failed to get label instructions' }));
    throw new Error(err.message || 'Failed to get label instructions');
  }

  const json = await res.json();
  const raw = json.data || {};
  // Backend returns { view, labels: [{ number, position, short_label, full_description }] }
  // Transform into frontend shape { steps, alternateLocations, safetyTips }
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const labels: any[] = raw.labels || [];
  const steps: string[] = labels
    .map((l) => l.full_description || l.description || l.short_label || '')
    .filter((s: string) => s.length > 0);
  const alternateLocations: string[] = labels
    .slice(1)
    .map((l) => {
      const label = l.short_label || l.position || '';
      const pos = (l.position || '').replaceAll('_', ' ');
      return label && pos ? `${label} (${pos})` : label || pos;
    })
    .filter((s: string) => s.length > 0);
  const safetyTips: string[] = [
    'Unplug the appliance before reaching behind or underneath it.',
    'Use a flashlight if the label area is dimly lit.',
    'Take a photo of the label for future reference.',
  ];
  const result: LabelLocationInstructions = {
    brand,
    category,
    subcategory,
    steps: steps.length > 0 ? steps : [`Check the back panel of your ${brand} ${subcategory} for the product label.`],
    alternateLocations,
    safetyTips,
  };
  return result;
};

export const generateVisualGuide = async (
  brand: string,
  category: string,
  subcategory: string,
  assetType?: string,
  wireframe?: { labelZone?: string }
): Promise<string> => {
  const zone = wireframe?.labelZone || 'back';
  const labelHintByZone: Record<string, string> = {
    bottom: 'on the underside / bottom surface',
    insideDoor: 'inside the door frame, visible when the door is open',
    side: 'on the side panel',
    top: 'on the top surface',
    back: 'on the rear / back panel',
  };
  const viewAngleByZone: Record<string, string> = {
    bottom: 'bottom view (device flipped upside down)',
    insideDoor: 'front view with door open',
    side: 'side view',
    top: 'top view',
    back: 'rear view',
  };

  // V1 AI endpoint for wireframe generation
  const res = await fetch(`${API_BASE}/v1/ai/generate-wireframe`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      ...getAuthHeader(),
      ...getTenantHeader(),
    },
    body: JSON.stringify({
      assetType: category,
      brand,
      subCategory: subcategory,
      labelHint: labelHintByZone[zone] || labelHintByZone.back,
      viewAngle: viewAngleByZone[zone] || viewAngleByZone.back,
      specificAssetType: assetType || category,
    }),
  });

  if (!res.ok) {
    const err = await res.json().catch(() => ({ message: 'Failed to generate visual guide' }));
    throw new Error(err.message || 'Failed to generate visual guide');
  }

  const json = await res.json();
  const raw = json.data || {};
  // Backend returns { image: "base64string" } â€” convert to blob URL for efficient rendering
  if (raw.image) {
    try {
      const byteChars = atob(raw.image);
      const byteArray = new Uint8Array(byteChars.length);
      for (let i = 0; i < byteChars.length; i++) byteArray[i] = byteChars.codePointAt(i) ?? 0;
      const blob = new Blob([byteArray], { type: 'image/png' });
      return URL.createObjectURL(blob);
    } catch {
      return `data:image/png;base64,${raw.image}`;
    }
  }
  return raw.url || '';
};

// â”€â”€â”€ PRODUCT IMAGE LOOKUP â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
// Calls backend proxy â€” keeps API key server-side and avoids CORS

export interface ProductImageResult {
  imageUrl: string;
  detectedProductType?: string | null;
  correctedName?: string | null;
  detectedProductTitle?: string | null;
}

/**
 * Resolve the best product image via SerpAPI.
 *
 * Mirrors the app's resolveProductImage() payload exactly so both clients
 * send the same request and receive the same quality of result.
 *
 * Field priority inside the backend:
 *   manufacturer > brand  (manufacturer is more specific)
 *   assetType   > category (assetType is the Step-1 validated type)
 *   productTitle (Priority 1 in buildImageQuery â€” most specific query)
 */


export interface ProductImageInfo {
  original: string;
  thumbnail: string;
  title: string;
  source: string;
  link: string;
}

export interface FindBestImageResult {
  bestImage: ProductImageInfo | null;
  genericImage: ProductImageInfo | null;
  /** 'exact' = brand+model found in image title | 'brand' = brand only | 'generic' = no match */
  matchQuality: 'exact' | 'brand' | 'generic' | null;
  /** Top-N ranked, type-safe options (up to 3) for the user to choose from. */
  candidates: ProductImageInfo[];
}

export const findBestProductImage = async (params: {
  brand: string;
  model: string;
  category?: string;
  productSubtype?: string;
  searchQueries?: string[];
  productDescription?: string;
}): Promise<FindBestImageResult> => {
  // Backend returns image objects keyed by `url` (+ confidence/query); the UI
  // expects ProductImageInfo with `original`. Map the fields and absolutise any
  // relative curated/seed paths so <img src> works from the frontend origin.
  const res = await apiFetch<{ success: boolean; data: { bestImage: Record<string, unknown> | null; genericImage: Record<string, unknown> | null; matchQuality: FindBestImageResult['matchQuality']; candidates?: Array<Record<string, unknown>> } }>('/v1/ai/find-best-product-image', {
    method: 'POST',
    body: params,
  });
  const mapInfo = (img: Record<string, unknown> | null | undefined): ProductImageInfo | null => {
    if (!img) return null;
    const src = toAbsoluteImageUrl((img.original as string) ?? (img.url as string));
    if (!src) return null;
    return {
      original: src,
      thumbnail: toAbsoluteImageUrl(img.thumbnail as string) || src,
      title: (img.title as string) ?? '',
      source: (img.source as string) ?? '',
      link: (img.link as string) ?? '',
    };
  };
  // Prefer the candidates array (top 3); fall back to bestImage + genericImage
  // for older backends that don't return it.
  const candidates = (res.data?.candidates ?? [])
    .map(mapInfo)
    .filter((c): c is ProductImageInfo => c !== null);
  const bestImage = mapInfo(res.data?.bestImage);
  const genericImage = mapInfo(res.data?.genericImage);
  return {
    bestImage,
    genericImage,
    matchQuality: res.data?.matchQuality ?? null,
    candidates:
      candidates.length > 0
        ? candidates
        : [bestImage, genericImage].filter((c): c is ProductImageInfo => c !== null),
  };
};

/**
 * Multi-query product image search via SerpAPI.
 * Uses GPT-generated search queries for targeted results.
 * Mirrors the Flutter app's ChatGPTService.searchProductImages().
 */
export interface SearchImagesResponse {
  success: boolean;
  candidates: Array<{
    original: string;
    thumbnail: string;
    source: string;
    title: string;
    link: string;
    isProduct: boolean;
    score: number;
  }>;
}

export const searchProductImages = async (params: {
  queries?: string[];
  brand?: string;
  model?: string;
  productType?: string;
  productDescription?: string;
  maxResults?: number;
}): Promise<SearchImagesResponse> => {
  const res = await apiFetch<{ success: boolean; data: SearchImagesResponse }>('/v1/ai/search-images', {
    method: 'POST',
    body: params,
  });
  return res.data;
};

export interface LookupImageOptions {
  assetId?: string;
  forceRefresh?: boolean;
  productTitle?: string;
  assetType?: string;
  manufacturer?: string;
  serial?: string;
  /** Form factor (e.g. "french-door", "front-load") — drives curated brand+form image matching. */
  productSubtype?: string;
}

export const lookupProductImage = async (
  brand: string,
  model: string,
  subcategory: string,
  options: LookupImageOptions = {},
): Promise<ProductImageResult> => {
  const { assetId, forceRefresh, productTitle, assetType, manufacturer, serial, productSubtype } = options;
  const res = await apiFetch<{ success: boolean; data: { productImageUrl: string | null; imageUrl: string | null; detectedProductType?: string | null; correctedName?: string | null; detectedProductTitle?: string | null } }>('/v1/ai/resolve-product-image', {
    method: 'POST',
    body: {
      brand,
      model,
      category: subcategory,
      ...(assetType ? { assetType } : {}),
      ...(manufacturer ? { manufacturer } : {}),
      ...(productTitle ? { productTitle } : {}),
      ...(serial ? { serial } : {}),
      ...(productSubtype ? { productSubtype } : {}),
      ...(assetId ? { assetId } : {}),
      ...(forceRefresh ? { forceRefresh: true } : {}),
    },
  });
  return {
    imageUrl: toAbsoluteImageUrl(res.data?.productImageUrl || res.data?.imageUrl || ''),
    detectedProductType: res.data?.detectedProductType ?? null,
    correctedName: res.data?.correctedName ?? null,
    detectedProductTitle: res.data?.detectedProductTitle ?? null,
  };
};
